import FetchCall from '../../../shared/local_fetch_call'
const namespaced = true

const state = {
  section: 'none',
  number: 1,
  paymentFields: {},
  hotelInCart: true,
  topDiv: null,
  applyCredit: true,
  creditAmount:0,
  potentialCredit: 0,
  orderTotal:0,
  billing: {
    address1: '',
    address2: '',
    city: '',
    companyName: '',
    corporate: false,
    country: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    purchaseOrderNumber: '',
    state: '',
    zipCode: ''
  },
}

const mutations = {
  updatePaymentFields(state, newFields) {
    const pf = state.paymentFields
    state.paymentFields = Object.assign({}, pf, newFields)
  },
  updateHotelInCart(state, hotelInCart) {
    state.hotelInCart = hotelInCart
  },
  updateCreditAmount(state, amount) {
    state.creditAmount = amount
  },
  toggleCreditApplication(state){
    state.applyCredit = !state.applyCredit
  },
  setOriginalCredit(state, amount){
    state.potentialCredit=amount
  },
  updateOrderTotal(state, amount) {
    state.orderTotal = amount
  },
  updateSection(state, section) {
    let cart = document.getElementById('checkoutVue').getElementsByClassName('sidebar-cart')[0]
    if(section == 'review'){
      cart.classList.remove('open')
    } else {
      if (!cart.classList.contains('open')){
        cart.classList.add('open')
      }
    }
    if (state.section == section) {
      state.section = 'none'
    } else {
      if (state.topDiv) {
        state.topDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
      state.section = section
    }
  },
  updateSectionNumber(state, numberOfAddOns) {
    if (numberOfAddOns > 0) {
      state.number = 0
    } else {
      state.number = 1
    }
  },

  setTopDiv(state, div) {
    state.topDiv = div
  },
  updateFirstName(state, firstName) {
    state.billing.firstName = firstName
  },
  updateAddress1(state, address1) {
    state.billing.address1 = address1
  },
  updateAddress2(state, address2) {
    state.billing.address2 = address2
  },
  updateCity(state, city) {
    state.billing.city = city
  },
  updateCompanyName(state, name) {
    state.billing.companyName = name
  },
  updateCorporate(state, value) {
    state.billing.corporate = value
  },
  updateCountry(state, country) {
    state.billing.country = country
  },
  updateLastName(state, lastName) {
    state.billing.lastName = lastName
  },
  updatePhoneNumber(state, phoneNumber) {
    state.billing.phoneNumber = phoneNumber
  },
  updatePurchaseOrderNumber(state, pon) {
    state.billing.purchaseOrderNumber = pon
  },
  updateState(state, stateName) {
    state.billing.state = stateName
  },
  updateZipCode(state, zipCode) {
    state.billing.zipCode = zipCode
  },
}

const actions = {
  async updateSection({ commit, state }, section) {
    let replacedSection = state.section
    commit('updateSection', section)

    if (replacedSection == 'hotel' && state.paymentFields.roomInformation.length > 0) {
      updateHotelReservationInfo(state.paymentFields.roomInformation)
    }
  },
}

const getters = {

}

const updateHotelReservationInfo = async (roomInformation) => {
  roomInformation.forEach(async info => {
    let body = JSON.stringify({
      hotel_reservations: {
        name: info.name,
        number_of_adults: info.numberOfAdults
      }
    })
    await FetchCall.fetchWithoutLocale(
      `/api/checkout_hotel_reservations/${info.id}`,
      'PUT',
      body
    )
  })
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
